import Styles from './TextDrawer.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'

interface Props extends DrawerProps {
  text: string
  title: string
}

export const TextDrawer = observer(({ text, title, ...props }: Props) => {
  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>{title}</Heading>
              </Drawer.Title>
              <Drawer.Close label="Close" variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container className={Styles.container}>{text}</Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
